/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_dynamodb_all_tables_region": "ap-southeast-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "involvedtb-dev",
            "region": "ap-southeast-1"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "involvedapi",
            "endpoint": "https://143xr33za4.execute-api.ap-southeast-1.amazonaws.com/dev",
            "region": "ap-southeast-1"
        }
    ]
};


export default awsmobile;
